import React,{useEffect, useState} from "react";
import {useOutletContext} from "react-router-dom";
import SubmitButton from "../../../../components/SubmitButton/SubmitButton";
import useForm from "../../../../customHooks/useForm";
import MyAccountContentHeader from "../MyAccountContentHeader/MyAccountContentHeader";
import "./MyAccountChangePassword.css";
import * as translator from '../../../../utils/translator';
import * as http from "../../../../utils/http";
import InputField from "../../../../components/CredentialsInput/InputField";
import { useCustomer } from "../../../../customHooks/useCustomer";
import ForgotPasswordModal from "../../../../components/Modals/ForgotPasswordModal/ForgotPasswordModal";
import InnerHTMLRenderer from "../../../../components/InnerHTMLRenderer/InnerHTMLRenderer";

const MyAccountChangePassword = () => {
  const {setActiveMenuLinkId , setStickyNotificationDetails ,language, customer } = useOutletContext<any>();
  const { logout } = useCustomer();

  // Social signups (Google) have no password, so the "old password" form cannot work for them.
  // They get a reset link instead; strict === false keeps the form when the flag is missing.
  const needsPasswordSetup = customer?.hasPassword === false;
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetAttempt, setResetAttempt] = useState(0);
  const [resetLinkSent, setResetLinkSent] = useState(false);

  // The reset-password route redirects logged-in customers away, so log out once the link is on its way.
  const closeResetModal = () => {
    setShowResetModal(false);
    if (resetLinkSent) {
      logout();
    }
  };


  let changePasswordFormAttributes = useForm({
    old_password:"",
    password : "",
    repeat_password : "",
  },language)

  useEffect(() => {
    setActiveMenuLinkId("change-password");
  },[]);

  const onSubmit = () => {
    if(changePasswordFormAttributes.validateForm()){
      http
      .postToServer(`account-update/password`,
      {
        oldPassword:changePasswordFormAttributes.form.old_password,
        newPassword:changePasswordFormAttributes.form.password
      },
      [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.ENCRYPTED_BODY]
      )
      .then((response) => {
        const resMsg = response.data.stickyNotificationData
       setStickyNotificationDetails((currentDetails : any) => ({
          show: true,
          title: translator.translate(language, "my_account", `stickyNotifications/success/ChangePassword/${resMsg}`),
          content: "",
          level : resMsg,
          showInfoIcon:true,
          refresh : !currentDetails.refresh
        }))

        setTimeout(() => {
          logout();
        }, 3 * 1000);

      })
      .catch((error) => {
        setStickyNotificationDetails((currentDetails : any) => ({
          show: true,
          title: "",
          content: translator.translate(language, "my_account", `stickyNotifications/error/error`),
          level : 'error',
          showInfoIcon:false,
          refresh : !currentDetails.refresh
        }))
      })
      .finally(()=> {
      })
    }
  }

  return(

    <>
      <div className="account-content">
        <MyAccountContentHeader
          title={translator.translate(language, "my_account", needsPasswordSetup ? `ChangePassword/noPasswordTitle` : `ChangePassword/title`)}
          description={needsPasswordSetup ? undefined : translator.translate(language, "my_account", `ChangePassword/subTitle`)}
        />

        {needsPasswordSetup ? (
          <>
          <div className="change-password-no-password">
            <div className="change-password-no-password-text">
              <InnerHTMLRenderer htmlContent={translator.translate(language, "my_account", `ChangePassword/noPasswordText1`)} />
              <p>{translator.translate(language, "my_account", `ChangePassword/noPasswordText2`)}</p>
            </div>
            <SubmitButton
              id={"change-password-send-reset-link"}
              placeholder={translator.translate(language, "my_account", `ChangePassword/noPasswordButton`)}
              onSubmit={() => {
                // New key remounts the modal, so a send stuck on a dismissed captcha challenge can be retried.
                setResetAttempt((attempt) => attempt + 1);
                setShowResetModal(true);
              }}
            />
          </div>
          {/* Outside the flex card: its captcha-only placeholder would otherwise add a gap while sending */}
            {showResetModal && (
              <ForgotPasswordModal
                key={resetAttempt}
                closeModal={closeResetModal}
                email={customer?.email}
                language={language}
                setStickyNotificationDetails={setStickyNotificationDetails}
                onSubmitted={() => setResetLinkSent(true)}
              />
            )}
          </>
        ) : (
        <div className="change-password-form">
          <div className="inputs-container">
            <InputField
                id="change-password-old-password"
                value={changePasswordFormAttributes.form.old_password}
                errorMsg={changePasswordFormAttributes.errorMessagePerField.old_password}
                type="password"
                placeholder={translator.translate(language, "my_account", `ChangePassword/oldPassword`)}
                mandatory
                onChange={(inputValue:string) =>
                  changePasswordFormAttributes.updateForm("old_password", inputValue)
                }
                language={language}
                onBlur={() => changePasswordFormAttributes.onFieldBlur("old_password")}
                touched={changePasswordFormAttributes.touched.password}
              />


              <InputField
                id="change-password"
                value={changePasswordFormAttributes.form.password}
                errorMsg={changePasswordFormAttributes.errorMessagePerField.password}
                type="password"
                placeholder={translator.translate(language, "my_account", `ChangePassword/newPassword`)}
                onChange={(inputValue:string) =>
                  changePasswordFormAttributes.updateForm("password", inputValue)
                }
                language={language}
                mandatory
                onBlur={() => changePasswordFormAttributes.onFieldBlur("password")}
                touched={changePasswordFormAttributes.touched.password}
              />

              <InputField
                id="change-password-repeat-password"
                value={changePasswordFormAttributes.form.repeat_password}
                errorMsg={changePasswordFormAttributes.errorMessagePerField.repeat_password}
                type="password"
                placeholder={translator.translate(language, "my_account", `ChangePassword/newPasswordVerification`)}
                onChange={(inputValue:string) =>
                  changePasswordFormAttributes.updateForm("repeat_password", inputValue)
                }
                language={language}
                mandatory
                onBlur={() => changePasswordFormAttributes.onFieldBlur("repeat_password")}
                touched={changePasswordFormAttributes.touched.repeat_password}
              />
          </div>

          <SubmitButton
            id={"change-password-submit"}
            placeholder={translator.translate(language, "my_account", `ChangePassword/submit`)}
            onSubmit={onSubmit}
          />
        </div>
        )}

      </div>
    </>
  )
};

export default MyAccountChangePassword;
